/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "bankingweb": {
            "nested": {
              "v1": {
                "nested": {
                  "Profile": {
                    "fields": {
                      "personToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": ".squareup.bbfrontend.bankingweb.v1.Profile.Name",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Name": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile?.nested?.Name) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Profile @ squareup/bbfrontend/bankingweb/v1/person_profile_service.proto at 12:1
 */
export const Profile = $root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile');
fixType(Profile);
Builder.createAndAttachToType(Profile);
/**
 * SOURCE Name @ squareup/bbfrontend/bankingweb/v1/person_profile_service.proto at 16:3
 */
Profile.Name = $root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile.Name');
fixType(Profile.Name);
Builder.createAndAttachToType(Profile.Name);